import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { hasValidProps, logException, ROUTES } from 'Utils';
import * as analytics from 'Utils/analytics';
import LoginButton from 'Components/LoginButton';
import ProgressBar from 'Components/ProgressBar';
const { EVENTS } = analytics;

const SocialLogin = (props) => {
  const [submitting, setSubmitting] = useState(false);
  const [availableProviders, setAvailableProviders] = useState(() => {
    // Providers this particular user has associated with their account
    const { providers } = props;
    // Providers configured for this application ID
    const { loginProviders: availableProvidersByApp } = props.applicationConfig;
    // availableProviders ends up with the intersection between providers and availableProvidersByApp since we only
    // want to display social providers that this particular application is configured for. If nothing exists the
    // user will automatically be converted to a native email account.
    return providers.filter((p) => availableProvidersByApp.includes(p));
  });

  useEffect(() => {
    if (!hasValidProps(props.email)) props.transitionTo(ROUTES.PAGE_HOME.url);
    else if (!availableProviders.length) requestPasswordSet();
  }, []);

  const requestPasswordSet = async () => {
    analytics.event({ action: EVENTS.continue, label: 'setAPassword' });
    setSubmitting(true);
    try {
      const { email, transitionTo, uim } = props;
      await uim.uimApi.passwordReset(email);
      transitionTo(ROUTES.PAGE_SET_PASSWORD.url, { email });
    } catch (err) {
      // RBMN-6263 let's swallow error message to expose less info for security
      logException(err);
      // We should probably show an error message or redirect to the notification page
    }
  };

  const handleClick = (provider) => {
    setSubmitting(true);
    props.routerCallback(provider);
  };

  if (!availableProviders.length) return <ProgressBar />;

  return (
    <>
      {submitting && <ProgressBar />}
      <h1 className="page-heading capitalized-text">
        {props.strings.welcomeBack}
      </h1>
      {availableProviders.map((provider) => (
        <LoginButton
          disabled={submitting}
          key={provider}
          onClick={() => handleClick(provider)}
          provider={provider}
          text={props.strings.continueWith}
          type="detail"
        />
      ))}
      <div className="sublink" onClick={requestPasswordSet}>
        {props.strings.setPassword}
      </div>
    </>
  );
};

SocialLogin.propTypes = {
  applicationConfig: PropTypes.object.isRequired,
  email: PropTypes.string.isRequired,
  providers: PropTypes.array.isRequired,
  routerCallback: PropTypes.func.isRequired,
  strings: PropTypes.object.isRequired,
  transitionTo: PropTypes.func.isRequired,
  uim: PropTypes.object.isRequired,
};

export default SocialLogin;
